import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAnilistComponent } from './simple-icons-anilist.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAnilistComponent ],
    exports:      [ SimpleIconsAnilistComponent ],
    bootstrap:    []
})
export class SimpleIconsAnilistModule {}
